export default __webpack_public_path__ + "static/media/top-banner.a5eacb0c.png";